import React from 'react';

export const OOSeparator = () => {
  return <div className="tag-ds separator" />;
};

export default OOSeparator;
